import { GameImage, GamePrice, GamePlatforms } from "@/components/shared";
import { ColumnDef } from "@/components/shared/data-table";
import type { BaseListItem } from "@/types";

type RankItem = BaseListItem & { rank: number };

export function createRankColumns<T extends RankItem>(
  primaryColor: string
): ColumnDef<T>[] {
  return [
    {
      header: "Rank",
      accessorKey: "rank",
      sortable: true,
      sortKey: "rank",
      width: "w-14",
      cell: (item) => (
        <span className="font-bold text-[13px]" style={{ color: primaryColor }}>
          #{item.rank}
        </span>
      ),
    },
    {
      header: "Image",
      width: "w-[100px]",
      noPadding: true,
      cell: (item) => (
        <div className="w-[100px] h-[37px] flex-shrink-0">
          <GameImage
            src={item.capsule_image}
            alt={item.name}
            width={100}
            height={37}
            fillContainer
            className="transition-colors"
          />
        </div>
      ),
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (item) => (
        <span className="text-white font-medium text-[13px]">{item.name}</span>
      ),
    },
    {
      header: "Release",
      accessorKey: "release_date",
      cell: (item) => (
        <span className="text-[#8f98a0] text-[11px]">
          {item.release_date || "—"}
        </span>
      ),
    },
    {
      header: "Price",
      cell: (item) => (
        <GamePrice
          isFree={item.is_free}
          priceFinal={item.price_final}
          priceInitial={item.price_initial}
          priceDiscount={item.price_discount}
        />
      ),
    },
    {
      header: "Platforms",
      cell: (item) => (
        <GamePlatforms
          supportsWindows={item.supports_windows}
          supportsMac={item.supports_mac}
          supportsLinux={item.supports_linux}
        />
      ),
    },
  ];
}

